import { useQuery } from '@tanstack/react-query';

import { getV1IdentitiesOptions } from '../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hooks for the Topcon ID feature (Customer Service Support identity
 * search). See `../Settings/IdentityProviders/identityProviders.queries.ts`
 * for the pattern.
 */

/**
 * Searches identities whose email starts with `emailFilter`. The search only
 * runs once enabled and the filter is at least 4 characters long; a missing
 * filter lists unfiltered.
 */
export function useIdentities({
  page,
  limit,
  emailFilter,
  isEnabled,
}: {
  page?: number;
  limit?: number;
  emailFilter?: string;
  isEnabled?: boolean;
}) {
  return useQuery({
    ...getV1IdentitiesOptions({
      query: {
        ...(page !== undefined && { page }),
        ...(limit !== undefined && { limit }),
        ...(emailFilter && { 'filter[email]': { startswith: emailFilter } }),
      },
    }),
    enabled: isEnabled && (emailFilter === undefined || emailFilter.length >= 4),
  });
}
